import { FormControl, FormErrorMessage, forwardRef } from "@chakra-ui/react";
import { FormProvider, useForm } from "react-hook-form";
import Input from "../inputs/Input";
import Select from "../inputs/Select";
import { TicketStatus } from "../../types/ticket.types";
import i18n from "../../i18n";
import { Ref, useImperativeHandle } from "react";

type TicketStatusFormProps = {
	value: {
		status?: TicketStatus | "";
		discount?: number;
	};
	requireProof?: boolean;
};

export type TicketStatusFormHandler = {
	values: () => {
		status?: TicketStatus | "";
		discount?: number;
		proof?: boolean;
	};
	valid: () => Promise<boolean>;
};

const TicketStatusForm = forwardRef(
	({ value }: TicketStatusFormProps, ref: Ref<TicketStatusFormHandler>) => {
		const methods = useForm();

		useImperativeHandle(ref, () => ({
			values: () => {
				const values = methods.getValues();
				if (values?.status === TicketStatus.CLOSED) {
					return {
						...values,
					};
				}
				return {
					...values,
					proof: false,
				};
			},
			valid: async () => {
				return await methods.trigger();
			},
		}));
		return (
			<FormProvider {...methods}>
				<form style={{ marginTop: "32px", marginBottom: "32px" }}>
					<FormControl isInvalid={!!methods.formState.errors.label} mb={4}>
						<Select
							id="status"
							placeholder="Statut"
							defaultValue={value.status}
							{...methods.register("status", {
								required: "Ce champ est obligatoire",
							})}
						>
							<option value={TicketStatus.OPEN}>
								{i18n.t(`ticket.status.${TicketStatus.OPEN}`)}
							</option>
							<option value={TicketStatus.BLOCKED}>
								{i18n.t(`ticket.status.${TicketStatus.BLOCKED}`)}
							</option>
							<option value={TicketStatus.CLOSED}>
								{i18n.t(`ticket.status.${TicketStatus.CLOSED}`)}
							</option>
						</Select>
						<FormErrorMessage>
							<>{methods.formState.errors?.label?.message}</>
						</FormErrorMessage>
					</FormControl>

					<FormControl isInvalid={!!methods.formState.errors.label}>
						<Input
							id="discount"
							type="number"
							placeholder="Remise (facultatif)"
							defaultValue={value.discount}
							{...methods.register("discount")}
						></Input>
						<FormErrorMessage>
							<>{methods.formState.errors?.label?.message}</>
						</FormErrorMessage>
					</FormControl>
				</form>
			</FormProvider>
		);
	},
);

export default TicketStatusForm;
